import React, { useState } from "react"
import { withRouter } from "react-router-dom"
import ProfileBrief from "./ProfileBrief"
import ProgressTracker from "./ProgressTracker"
import Announcements from "./Announcements"
import { MembershipJourneyProvider } from "./MembershipJourneyContext"
import { resolveAcceptableProgressStanding } from "../../../utils/resolveAcceptableProgressStanding"
import { shouldUseTerminatedGptpCopy } from "../../../utils/shouldSuppressAdvancementCtas"
import { LEVEL } from "./utils/constants/levels"
import { GPTP_MESSAGE_VARIANT } from "./utils/suspensionUtils"
import {
  DashboardContainer,
  ContentGrid,
  MainContent,
  SidebarContent,
} from "./Styles/Dashboard.styles"

const MembershipJourneyDashboard = ({
  me,
  pgmProgress,
  onEditProfile,
  history,
  authReady,
  memberApplicationEligibility,
}) => {
  const initialLevel =
    pgmProgress?.currentLevelKey ||
    pgmProgress?.mostRecentCompletedLevelKey ||
    LEVEL.QUALIFYING
  const [activeLevel, setActiveLevel] = useState(initialLevel)

  const handleEditClick = () => {
    if (onEditProfile) {
      onEditProfile()
    } else if (history) {
      history.push("/profile/edit")
    } else {
      window.location.href = "/profile/edit"
    }
  }

  const progressStanding = resolveAcceptableProgressStanding({
    me,
    pgmProgress,
  })

  const contextValue = {
    me,
    pgaId: me?.pgaId,
    pgmProgress,
    progressStanding,
    memberApplicationEligibility,
    gptpMessageVariant: shouldUseTerminatedGptpCopy({
      standing: progressStanding,
    })
      ? GPTP_MESSAGE_VARIANT.TERMINATED
      : GPTP_MESSAGE_VARIANT.SUSPENDED,
  }

  return (
    <MembershipJourneyProvider value={contextValue}>
      <DashboardContainer>
        <ProfileBrief me={me} onEditClick={handleEditClick} authReady={true} />
        <ContentGrid>
          <MainContent>
            <ProgressTracker
              activeLevel={activeLevel}
              onLevelClick={setActiveLevel}
            />
          </MainContent>
          <SidebarContent>
            <Announcements
              mainProgramTypeCode={me?.mainProgramTypeCode}
              sectionName={me?.primarySection?.name}
              authReady={authReady}
            />
          </SidebarContent>
        </ContentGrid>
      </DashboardContainer>
    </MembershipJourneyProvider>
  )
}

export default withRouter(MembershipJourneyDashboard)
